import styled, { css } from 'styled-components';
const colorMixin = css `
  color: ${(props) => {
    if (props.type === 'secondary') {
        return 'var(--text-color-2)';
    }
    return 'var(--text-color-0)';
}};
`;
export const StyledTitle = styled.div `
  font-size: ${(props) => `${props.fontSize}px`};
  ${colorMixin}
`;
export const StyledSubTitle = styled.div `
  font-size: ${(props) => `${props.fontSize}px`};
  ${colorMixin}

  @apply font-normal m-0 bg-transparent;
`;
const ellipsisMixin = css `
  display: -webkit-box;
  -webkit-line-clamp: ${(props) => props.line};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
export const StyledParagraph = styled.p `
  font-size: 13px;
  white-space: pre-wrap;
  word-wrap: break-word;
  ${ellipsisMixin};
  ${colorMixin}
`;
